// extracted by mini-css-extract-plugin
module.exports = {"loadingScreen":"CommuLinoLoading_loadingScreen__vyw1s","logo":"CommuLinoLoading_logo__x9tJD","activeColor":"CommuLinoLoading_activeColor__1dki8"};